import React from 'react';
import './Products.css';

const Products = () => {
  const products = [
    {
      name: 'Engine Gaskets',
      description: 'High-quality engine gaskets for optimal sealing and performance.',
      image: 'https://tiimg.tistatic.com/fp/2/009/805/eicher-truck-parabolic-leaf-spring-515.jpg'
    },
    {
      name: 'Pistons & Rings',
      description: 'Durable pistons and rings for heavy commercial vehicle engines.',
      image: 'https://tiimg.tistatic.com/fp/2/009/805/eicher-truck-parabolic-leaf-spring-515.jpg'
    },
    {
      name: 'Cylinder Heads',
      description: 'Precision-engineered cylinder heads for maximum efficiency.',
      image: 'https://tiimg.tistatic.com/fp/2/009/805/eicher-truck-parabolic-leaf-spring-515.jpg'
    },
    {
      name: 'Timing Belts',
      description: 'Reliable timing belts ensuring smooth engine operation.',
      image: 'https://tiimg.tistatic.com/fp/2/009/805/eicher-truck-parabolic-leaf-spring-515.jpg'
    },
    {
      name: 'Leaf Springs',
      description: 'Heavy-duty leaf springs for superior suspension performance.',
      image: 'https://tiimg.tistatic.com/fp/2/009/805/eicher-truck-parabolic-leaf-spring-515.jpg'
    },
    {
      name: 'Hollow Springs',
      description: 'Advanced hollow springs for improved vehicle handling.',
      image: 'https://tiimg.tistatic.com/fp/2/009/805/eicher-truck-parabolic-leaf-spring-515.jpg'
    },
    {
      name: 'Shock Absorbers',
      description: 'Premium shock absorbers for enhanced ride comfort and stability.',
      image: 'https://tiimg.tistatic.com/fp/2/009/805/eicher-truck-parabolic-leaf-spring-515.jpg'
    },
    {
      name: 'Brake Pads',
      description: 'High-performance brake pads for reliable stopping power.',
      image: 'https://tiimg.tistatic.com/fp/2/009/805/eicher-truck-parabolic-leaf-spring-515.jpg'
    },
    {
      name: 'Brake Discs',
      description: 'Durable brake discs designed for heavy commercial vehicles.',
      image: 'https://tiimg.tistatic.com/fp/2/009/805/eicher-truck-parabolic-leaf-spring-515.jpg'
    },
    {
      name: 'Alternators',
      description: 'Efficient alternators for reliable electrical power generation.',
      image: 'https://tiimg.tistatic.com/fp/2/009/805/eicher-truck-parabolic-leaf-spring-515.jpg'
    },
    {
      name: 'Starters',
      description: 'Powerful starters for quick and reliable engine ignition.',
      image: 'https://tiimg.tistatic.com/fp/2/009/805/eicher-truck-parabolic-leaf-spring-515.jpg'
    },
    {
      name: 'Clutch Plates',
      description: 'Heavy-duty clutch plates for smooth transmission operation.',
      image: 'https://tiimg.tistatic.com/fp/2/009/805/eicher-truck-parabolic-leaf-spring-515.jpg'
    }
  ];

  return (
    <div className="products-page">
      <div className="products-hero">
        <h1 className="products-title">Our Products</h1>
        <p className="products-subtitle">
          High-quality aftermarket spare parts for heavy commercial vehicles
        </p>
      </div>

      <div className="products-container">
        <div className="products-intro">
          <p>
            GSPS Trading Corporation offers a comprehensive range of aftermarket spare parts 
            for VOLVO, BHARAT BENZ, EICHER, and MAN heavy commercial vehicles. Our extensive 
            inventory ensures you get the right parts when you need them.
          </p>
        </div>

        <div className="products-grid">
          {products.map((product, index) => (
            <div key={index} className="product-card">
              <div className="product-image-container">
                <img 
                  src={product.image} 
                  alt={product.name}
                  className="product-image"
                />
              </div>
              <div className="product-info">
                <h3 className="product-name">{product.name}</h3>
                <p className="product-description">{product.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="products-cta">
          <p className="cta-text">Need a specific part? Contact us for availability and pricing.</p>
          <a href="#contact" className="cta-button">Contact Us</a>
        </div>
      </div>
    </div>
  );
};

export default Products;

